<template>
  <svg xmlns="http://www.w3.org/2000/svg" class="fill-current inline" :class="[width, height]" viewBox="0 0 40 40">
    <g id="edit" transform="translate(-295 -228)">
      <circle
        id="Ellipse_113"
        data-name="Ellipse 113"
        cx="20"
        cy="20"
        r="20"
        transform="translate(295 228)"
        fill="#f0324c"
      />
      <g id="Edit-2" data-name="Edit" transform="translate(307 240)">
        <rect id="Rectangle_324" data-name="Rectangle 324" width="16" height="16" fill="none" />
        <path
          id="Path_110"
          data-name="Path 110"
          d="M8.154,3.077,2.462,8.923,0,16l7.077-2.308L12.769,8Zm7.231-.462-2-2a1.865,1.865,0,0,0-2.769,0L8.923,2.308l4.615,4.769,1.846-1.846A1.95,1.95,0,0,0,16,3.846,1.9,1.9,0,0,0,15.385,2.615Z"
          fill="#fff"
        />
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  props: {
    width: {
      type: String,
      default: 'w-10'
    },
    height: {
      type: String,
      default: 'h-10'
    }
  }
}
</script>
